import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PackageImage from '../../../../../../generic/assets/package.png';
import { ContextModal } from '../../../../../../modules/modal/modalContext';
import { CHECK_ATTEMPTS } from '../../../../../../../store/actions/actionsTypes';
import { LINKS } from '../../../../../../Routs/config';
import { FormShell, FormField, FormFooter } from '../../../../../../generic/ui/FormLayout';
import IconTextField from '../../../../../../generic/ui/Input/IconTextField';
import { AccentButton } from '../../../../../../generic/ui/Button';
import selectOnFocus from '../../../../../../modules/autoselect';

interface Props {
    packQty: () => Record<string, number>;
    saveFunc: () => void;
    delta: number;
    saveCheckedPalletInfo: (data: any) => Promise<void>;
    likutInfo: any;
    artPass: string;
    palletDetails: any[];
    closeFunc?: (flag?: boolean) => void;
}

const ModalCheckArizot: React.FC<Props> = ({
    packQty,
    saveFunc,
    delta,
    saveCheckedPalletInfo,
    likutInfo,
    artPass,
    palletDetails,
    closeFunc,
}) => {
    const [t] = useTranslation(['likut', 'buttons']);
    const [modal, setModal] = useContext<any>(ContextModal);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const arizotSet = packQty();
    // legacy CheckArizotItem seeded every key with 0 on mount — keep that behavior
    const [arizotSetTemp, setArizotSetTemp] = useState<Record<string, number>>(() =>
        Object.keys(packQty()).reduce((acc: Record<string, number>, key) => {
            acc[key] = 0;
            return acc;
        }, {})
    );
    const [weightInput, setWeightInput] = useState(0);
    const [adminPass, setAdminPass] = useState('');
    const attemptsLeft = 3 - (likutInfo?.checkAttempts && likutInfo?.checkAttempts[likutInfo?.pallet?.palletNum] ? likutInfo?.checkAttempts[likutInfo?.pallet?.palletNum] : 0)
    const givenWeight = palletDetails.reduce((acc, item) => {
        return acc + (item?.WeightBrutto || 0)
    }, 0)

    const calcAttempts = () => {
        let checkCollection = likutInfo.checkAttempts || {};
        let palletNumber = likutInfo?.pallet?.palletNum
        checkCollection[palletNumber] = (checkCollection[palletNumber] + 1) || 1
        return checkCollection
    }

    const updateSetTemp = (key: string, value: number) => {
        setArizotSetTemp({
            ...arizotSetTemp,
            [key]: value
        })

    }
    const check = () => {
        let keys = Object.keys(arizotSet)
        for (let i in keys) {
            if (arizotSet[keys[i]] !== arizotSetTemp[keys[i]]) return false
        }
        return true
    }

    const checkWeight = () => {
        const difference = Math.abs(givenWeight - weightInput)
        return delta ? !(difference > delta) : !(difference > 0)
    }
    const save = async () => {
        if (attemptsLeft > 0 ? delta ? checkWeight() : check() : adminPass === artPass) {
            closeFunc?.();
            await saveCheckedPalletInfo([{ RecID: 0, CheckComment: 'arizotSetTemp' }]);
            saveFunc();
            navigate(LINKS.likut.likutExperess.palletSection)
        }
        else {
            if (attemptsLeft > 0) {
                dispatch({
                    type: CHECK_ATTEMPTS,
                    payload: calcAttempts()
                })
            } else {
                setModal({
                    open: true,
                    value: `סיסמה שגויה`,
                    mood: false
                });
                setTimeout(() => {
                    setModal({
                        open: false,
                        value: ''
                    });
                }, 3000);
                return
            }
            setModal({
                open: true,
                value: `כמות לא נכונה, נשאר עוד ${2 - (likutInfo.checkAttempts[likutInfo?.pallet?.palletNum] ? likutInfo.checkAttempts[likutInfo?.pallet?.palletNum] : 1)} נסיון`,
                mood: false
            });
            setTimeout(() => {
                setModal({
                    open: false,
                    value: ''
                });
            }, 3000);
        }
    }

    return (
        <FormShell>
            <TitleImg src={PackageImage} alt='check' />
            {attemptsLeft > 0 ? (
                delta ? (
                    <FormField label={t('likut_modal_checkpallet_weight')} fullWidth>
                        <IconTextField
                            type='number'
                            value={weightInput || ''}
                            onChange={(e) => setWeightInput(Number(e.target.value))}
                            onClick={selectOnFocus}
                        />
                    </FormField>
                ) : (
                    <>
                        {Object.keys(arizotSet).map((item) => (
                            <FormField key={item} label={item} fullWidth>
                                <IconTextField
                                    type='number'
                                    value={arizotSetTemp[item] ?? ''}
                                    onChange={(e) => updateSetTemp(item, Number(e.target.value))}
                                    onClick={selectOnFocus}
                                />
                            </FormField>
                        ))}
                    </>
                )
            ) : (
                <>
                    <AttemptsWarning>
                        <span>השתמשו בכל הניסיונות</span>
                        <span>נא להזין סיסמה</span>
                    </AttemptsWarning>
                    <FormField label={t('likut_modal_checkpallet_admin_pass')} fullWidth>
                        <IconTextField
                            type='password'
                            autoComplete='new-password'
                            value={adminPass}
                            onChange={(e) => setAdminPass(e.target.value)}
                        />
                    </FormField>
                </>
            )}
            <FormFooter>
                <AccentButton type='button' onClick={save} fullWidth={false}>
                    {t('save', { ns: 'buttons' })}
                </AccentButton>
            </FormFooter>
        </FormShell>
    );
};

export default ModalCheckArizot;

const TitleImg = styled.img`
    width: 100%;
    max-width: 220px;
    align-self: center;
`;

const AttemptsWarning = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    padding: 0.5rem 0.75rem;
    direction: rtl;
    border: 1px solid ${({ theme }) => theme.colors.danger};
    border-radius: ${({ theme }) => theme.radii.md};
    color: ${({ theme }) => theme.colors.danger};
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.sm};
    font-weight: 600;
`;
